<template>
    <button
        v-if="color !== ''"
        :style="'background-color: ' + color + '; border: thin solid ' + color"
        @click="e => $emit('click', e.target.clicked)"
    ></button>
    <button v-else :style="'border: thin solid grey'" @click="e => $emit('click', e.target.clicked)"></button>
</template>
<script>
export default {
    props: ["color"]
};
</script>
<style scoped lang="scss">
button {
    background-color: transparent;
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    transition: 0.3s ease-in-out;
    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    }
}
</style>



// WEBPACK FOOTER //
// ItemColor.vue?edfb1766